import React, { type PropsWithChildren } from 'react';

import { FormControlLabel, type Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type SxProps } from '@mui/system';

import { IconTooltip } from '../../../components/common/Tooltip/IconTooltip';

const StyledFormControlLabel = styled(FormControlLabel)`
    display: flex;
    margin-right: 0;
`;

export interface AdminControlProps {
    control: React.ReactElement<any, any>;
    label: string;
    value?: string;
    sx?: SxProps<Theme>;
    hint?: string;
}

export const AdminControlCheckbox = (props: PropsWithChildren<AdminControlProps>) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <StyledFormControlLabel control={props.control} label={props.label} sx={props.sx} />
        {props.hint && <IconTooltip>{props.hint}</IconTooltip>}
    </div>
);
